export default __webpack_public_path__ + "static/media/title.006b69fe.png";